"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaContextProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const lite_1 = require("dequal/lite");
const reducers_1 = require("../../reducers");
const types_1 = require("../../types");
const services_1 = require("../../services");
const context_1 = require("../../context");
const initialState = {
    status: types_1.AlgoliaStatus.IDLE,
    queries: {},
    results: {},
};
const AlgoliaContextProvider = ({ children, client, }) => {
    const [state, dispatch] = (0, react_1.useReducer)(reducers_1.AlgoliaSearchReducer, initialState);
    const [error, setError] = (0, react_1.useState)(undefined);
    const { queries, results } = state;
    const previousQueriesRef = (0, react_1.useRef)(queries);
    const [isInitialRequest, setIsInitialRequest] = (0, react_1.useState)(true);
    (0, react_1.useEffect)(() => {
        const isQueriesUpdated = !(0, lite_1.dequal)(queries, previousQueriesRef.current);
        const fetchAlgoliaObjects = async () => {
            const queryKeys = Object.keys(queries);
            if (queryKeys.length && isQueriesUpdated) {
                // If initialState is provided, we skip the first request.
                // Subsequent updates to query will trigger another request
                const queryIds = queryKeys.filter(queryKey => {
                    const query = queries[queryKey];
                    const isQueryUpdated = !(0, lite_1.dequal)(query, previousQueriesRef.current[queryKey]);
                    return isInitialRequest ? !query.initialState : isQueryUpdated;
                });
                if (queryIds.length) {
                    dispatch({
                        type: types_1.AlgoliaActionType.SET_STATUS,
                        value: types_1.AlgoliaStatus.LOADING,
                    });
                    setError(undefined);
                    const searchResult = await (0, services_1.search)({
                        client,
                        queries: queryIds.map(queryId => queries[queryId]),
                    });
                    searchResult.forEach((result, index) => {
                        dispatch({
                            type: types_1.AlgoliaActionType.SET_RESULT,
                            value: {
                                key: queryIds[index],
                                result,
                            },
                        });
                    });
                    dispatch({
                        type: types_1.AlgoliaActionType.SET_STATUS,
                        value: types_1.AlgoliaStatus.IDLE,
                    });
                }
                if (isInitialRequest) {
                    setIsInitialRequest(false);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        fetchAlgoliaObjects().catch(e => {
            dispatch({
                type: types_1.AlgoliaActionType.SET_STATUS,
                value: types_1.AlgoliaStatus.ERROR,
            });
            setError({ ...e, name: 'AlgoliaError' });
        });
    }, [client, isInitialRequest, queries, previousQueriesRef, results]);
    (0, react_1.useEffect)(() => {
        previousQueriesRef.current = queries;
    }, [queries]);
    return ((0, jsx_runtime_1.jsx)(context_1.algoliaContext.Provider, { value: { state, error, dispatch }, children: children }));
};
exports.AlgoliaContextProvider = AlgoliaContextProvider;
//# sourceMappingURL=AlgoliaContextProvider.js.map